export default __webpack_public_path__ + "static/media/login-img.fc2191c2.png";